<template>
  <editable-base
    ref="base"
    :mode="mode"
    :label="label"
    :error-message="errorMessage"
    :readonly="readonly"
    :show-buttons="showButtons"
    :showErrorMessage="showErrorMessage"
  >
    <template v-if="mode === modes.edit">
      <b-input-group>
        <b-input-group-prepend>
          <b-input-group-text>subject / object / possessive</b-input-group-text>
        </b-input-group-prepend>
        <template v-for="(value, index) in this.editValue">
          <b-form-input
            :key="`field_${index}`"
            @click="handleMaybeEditClick"
            :class="[
              'est-input',
              mode === modes.processing ? 'text-secondary' : '',
              readonly ? 'readonly' : ''
            ]"
            :id="id"
            v-model="editValue[index]"
            :plaintext="mode !== modes.edit"
            :readonly="readonly"
          /> </template></b-input-group></template
    ><template v-else-if="editValue">
      <b-form-input
        :plaintext="true"
        @click="handleMaybeEditClick"
        :value="editValue.join(separator)"
      >
      </b-form-input> </template
    ><template v-else>
      <p @click="handleMaybeEditClick" class="text-muted small font-italic">
        no value set {{ readonly ? "" : "&mdash; click to add" }}
      </p>
    </template>
  </editable-base>
</template>

<script>
import {
  BInputGroup,
  BInputGroupText,
  BInputGroupPrepend,
  BFormInput
} from "bootstrap-vue";
import { IsNotEmptyString } from "@/components/lib/Validation";
import EditableBase, { Mixin } from "./EditableBase";

const separator = "/";

export default {
  name: "EditablePronouns",
  mixins: [Mixin],
  data() {
    return {
      value: this.decomposeStringValue(this.initialValue),
      editValue: this.decomposeStringValue(this.initialValue),
      separator: separator,
      defaultValues: ["they", "them", "theirs"]
    };
  },
  methods: {
    decomposeStringValue(pronouns) {
      return pronouns.split(separator);
    },
    setValue(value) {
      if (Array.isArray(value)) {
        this.value = value.slice();
        this.editValue = value.slice();
      } else {
        this.value = this.decomposeStringValue(value);
        this.editValue = this.decomposeStringValue(value);
      }
    },
    preSaveValueProcessor(values) {
      // ensure any falsy items are replaced with the default value
      return values
        .map((value, index) => {
          return IsNotEmptyString(value).isValid
            ? value
            : this.defaultValues[index];
        })
        .join(separator);
    },
    preValidateValueProcessor(value) {
      return this.preSaveValueProcessor(value);
    },
    isDirty() {
      return (
        this.preSaveValueProcessor(this.editValue) !==
        this.preSaveValueProcessor(this.value)
      );
    }
  },
  components: {
    BInputGroup,
    BFormInput,
    BInputGroupPrepend,
    BInputGroupText,
    EditableBase
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
